import { CommonModule, TitleCasePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { ModelAttributeModule } from '../../notes/model-attribute/model-attribute.module';
import { StatusModule } from '../../notes/status/status.module';
import { TabsModule } from '../../notes/tabs/tabs.module';
import { ProgressBarGridModule } from '../progress-bar-grid/progress-bar-grid.module';
import { PoliciesCardComponent } from './policies-card.component';

@NgModule({
  declarations: [PoliciesCardComponent],
  imports: [
    CommonModule,
    TabsModule,
    ModelAttributeModule,
    ProgressBarGridModule,
    StatusModule,
  ],
  providers: [TitleCasePipe],
  exports: [PoliciesCardComponent],
})
export class PoliciesCardModule {}
